import type { Channel, Metric } from "../../types/analytics";
import { deltaPct, deltaPt, int, roasStr, sumChannels, yen, type Delta } from "../../lib/analyticsCalc";

interface KpiCardsProps {
  totals: Record<Channel, Metric>;
  prevTotals: Record<Channel, Metric>;
  activeChannels: Channel[];
  hasPrev: boolean;
}

function roasValue(m: Metric): number {
  return m.ad_spend > 0 ? m.sales / m.ad_spend : 0;
}

export function KpiCards({ totals, prevTotals, activeChannels, hasPrev }: KpiCardsProps) {
  const cur = sumChannels(totals, activeChannels);
  const prev = sumChannels(prevTotals, activeChannels);

  const cvrDelta: Delta = deltaPt(cur.orders, cur.sessions ?? 0, prev.orders, prev.sessions ?? 0, hasPrev && cur.sessions != null && prev.sessions != null);

  const kpis: { label: string; value: string; delta: Delta }[] = [
    { label: "売上", value: yen(cur.sales), delta: deltaPct(cur.sales, prev.sales, hasPrev) },
    {
      label: "アクセス（セッション）",
      value: cur.sessions != null ? int(cur.sessions) : "—",
      delta: cur.sessions != null && prev.sessions != null ? deltaPct(cur.sessions, prev.sessions, hasPrev) : { text: "—", color: "#9A958B" },
    },
    { label: "注文数", value: int(cur.orders), delta: deltaPct(cur.orders, prev.orders, hasPrev) },
    { label: "転換率", value: cur.sessions ? ((cur.orders / cur.sessions) * 100).toFixed(2) + "%" : "—", delta: cvrDelta },
    { label: "広告費", value: yen(cur.ad_spend), delta: deltaPct(cur.ad_spend, prev.ad_spend, hasPrev, true) },
    { label: "ROAS", value: roasStr(cur.sales, cur.ad_spend), delta: deltaPct(roasValue(cur), roasValue(prev), hasPrev) },
  ];

  return (
    <section className="an-kpi-grid">
      {kpis.map((k) => (
        <div className="an-kpi-card" key={k.label}>
          <div className="an-kpi-label">{k.label}</div>
          <div className="an-kpi-value">{k.value}</div>
          <div className="an-kpi-delta">
            <span className="an-kpi-delta-value" style={{ color: k.delta.color }}>
              {k.delta.text}
            </span>
            <span className="an-kpi-delta-label">前期間比</span>
          </div>
        </div>
      ))}
    </section>
  );
}
